import { render } from "./EditorActivity.vue?vue&type=template&id=08f7e557&ts=true"
import script from "./EditorActivity.vue?vue&type=script&lang=ts"
export * from "./EditorActivity.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../sf-playbook-app/APP/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__